export default __webpack_public_path__ + "static/media/flayer8.1a446df6.jpg";